export interface ArtistEntry {
  id: string
  name: string
}

export interface AlbumEntry {
  id: string
  term: string
  artist: string
  title: string
  genre: string
  artistId: string
  artworkUrl: string
  pixelatedArtworkUrl?: string
  selectedGenre?: string
}

export const musicGenres = [
  '2 tone',
  '2-step',
  'acid house',
  'acid jazz',
  'acid rock',
  'acid techno',
  'acid trance',
  'acoustic blues',
  'acoustic rock',
  'afoxê',
  'african blues',
  'afrobeat',
  'aggrotech',
  'alternative country',
  'alternative dance',
  'alternative folk',
  'alternative hip hop',
  'alternative metal',
  'alternative pop',
  'alternative punk',
  'alternative rock',
  'ambient',
  'ambient dub',
  'ambient house',
  'ambient pop',
  'ambient techno',
  'ambient trance',
  'american primitive guitar',
  'americana',
  'anarcho-punk',
  'anatolian rock',
  'andalusian classical',
  'anti-folk',
  'aor',
  'appalachian folk',
  'arena rock',
  'ars antiqua',
  'ars nova',
  'ars subtilior',
  'art pop',
  'art punk',
  'art rock',
  'atmospheric black metal',
  'avant-garde',
  'avant-garde jazz',
  'avant-garde metal',
  'avant-garde pop',
  'avant-prog',
  'axé',
  'bachata',
  'baião',
  'balearic beat',
  'ballad',
  'baltimore club',
  'barbershop',
  'bardcore',
  'baroque',
  'baroque pop',
  'bass house',
  'bassline',
  'battle rap',
  'batucada',
  'beat music',
  'bebop',
  'benga',
  'berlin school',
  'bhangra',
  'big band',
  'big beat',
  'black metal',
  'blackened death metal',
  'blackgaze',
  'bleep techno',
  'blue-eyed soul',
  'bluegrass',
  'bluegrass gospel',
  'blues',
  'blues rock',
  'bolero',
  'bolero son',
  'bongo flava',
  'boogie rock',
  'boogie-woogie',
  'boom bap',
  'bossa nova',
  'bounce',
  'breakbeat',
  'breakbeat hardcore',
  'breakcore',
  'breaks',
  'brega',
  'brega funk',
  'brill building',
  'brit funk',
  'britcore',
  'britpop',
  'broken beat',
  'brostep',
  'brutal death metal',
  'bubblegum bass',
  'bubblegum pop',
  'cabaret',
  'cajun',
  'calypso',
  'canción melódica',
  'candombe',
  'canterbury scene',
  'cantopop',
  'canzone napoletana',
  'cape jazz',
  'carimbó',
  'carnatic classical',
  'celtic',
  'celtic punk',
  'chacarera',
  'chachachá',
  'chalga',
  'chamamé',
  'chamber pop',
  'champeta',
  'changüí',
  'chanson à texte',
  'chanson française',
  'chicago blues',
  'chicano rap',
  'chillout',
  'chillstep',
  'chillwave',
  'chimurenga',
  'chiptune',
  'chopped and screwed',
  'choro',
  'christian metal',
  'christian rock',
  'christmas music',
  'chutney',
  'city pop',
  'classic blues',
  'classic country',
  'classic jazz',
  'classic rock',
  'classical',
  'classical crossover',
  'cloud rap',
  'club',
  'coco',
  'coldwave',
  'comedy',
  'comedy hip hop',
  'comedy rock',
  'compas',
  'complextro',
  'conscious hip hop',
  'contemporary christian',
  'contemporary classical',
  'contemporary folk',
  'contemporary gospel',
  'contemporary jazz',
  'contemporary r&b',
  'contra',
  'cool jazz',
  'copla',
  'corrido',
  'country',
  'country blues',
  'country boogie',
  'country folk',
  'country pop',
  'country rap',
  'country rock',
  'country soul',
  'coupé-décalé',
  'cowpunk',
  'crossover jazz',
  'crossover prog',
  'crossover thrash',
  'crunk',
  'crust punk',
  'cumbia',
  'cumbia villera',
  'cuplé',
  'cyber metal',
  'cybergrind',
  'cyberpunk',
  'd-beat',
  'dance',
  'dance-pop',
  'dance-punk',
  'dance-rock',
  'dancehall',
  'dangdut',
  'dansband',
  'danzón',
  'dark ambient',
  'dark cabaret',
  'dark electro',
  'dark folk',
  'dark jazz',
  'dark psytrance',
  'dark wave',
  'darkstep',
  'darksynth',
  'death \'n\' roll',
  'death industrial',
  'death metal',
  'death-doom metal',
  'deathcore',
  'deathgrind',
  'deathrock',
  'deathstep',
  'deconstructed club',
  'deep funk',
  'deep house',
  'delta blues',
  'denpa',
  'depressive black metal',
  'descarga',
  'desert blues',
  'desert rock',
  'detroit techno',
  'dhrupad',
  'digicore',
  'digital hardcore',
  'disco',
  'disco polo',
  'dixieland',
  'djent',
  'doo-wop',
  'doom metal',
  'doomcore',
  'downtempo',
  'dream pop',
  'dreampunk',
  'drill',
  'drill and bass',
  'drone',
  'drone metal',
  'drum and bass',
  'dub',
  'dub poetry',
  'dub techno',
  'dubstep',
  'dungeon synth',
  'east coast hip hop',
  'easy listening',
  'easycore',
  'ebm',
  'edm',
  'electric blues',
  'electro',
  'electro house',
  'electro swing',
  'electro-funk',
  'electro-industrial',
  'electroclash',
  'electronic',
  'electronic rock',
  'electronica',
  'electronicore',
  'electropop',
  'electropunk',
  'electrotango',
  'emo',
  'emo pop',
  'emo rap',
  'emocore',
  'enka',
  'éntekhno',
  'ethereal wave',
  'euro house',
  'euro-disco',
  'eurobeat',
  'eurodance',
  'europop',
  'exotica',
  'experimental',
  'experimental hip hop',
  'experimental rock',
  'extratone',
  'fado',
  'fidget house',
  'filk',
  'finnish tango',
  'flamenco',
  'flamenco jazz',
  'folk',
  'folk metal',
  'folk pop',
  'folk punk',
  'folk rock',
  'folktronica',
  'footwork',
  'forró',
  'forró eletrônico',
  'forró universitário',
  'freak folk',
  'freakbeat',
  'free folk',
  'free improvisation',
  'free jazz',
  'french house',
  'frevo',
  'fuji',
  'funaná',
  'funeral doom metal',
  'funk',
  'funk carioca',
  'funk metal',
  'funk rock',
  'funk soul',
  'funkot',
  'funktronica',
  'funky house',
  'fusion',
  'future bass',
  'future funk',
  'future garage',
  'future house',
  'future jazz',
  'futurepop',
  'g-funk',
  'gabber',
  'gagaku',
  'gangsta rap',
  'garage house',
  'garage punk',
  'garage rock',
  'ghazal',
  'ghetto house',
  'ghettotech',
  'glam',
  'glam metal',
  'glam punk',
  'glam rock',
  'glitch',
  'glitch hop',
  'glitch pop',
  'go-go',
  'goa trance',
  'goregrind',
  'gospel',
  'gothic',
  'gothic country',
  'gothic metal',
  'gothic rock',
  'grebo',
  'gregorian chant',
  'grime',
  'grindcore',
  'groove metal',
  'group sounds',
  'grunge',
  'guaguancó',
  'guajira',
  'guaracha',
  'gypsy jazz',
  'gypsy punk',
  'happy hardcore',
  'hard bop',
  'hard house',
  'hard rock',
  'hard trance',
  'hardbass',
  'hardcore hip hop',
  'hardcore punk',
  'hardcore techno',
  'hardstyle',
  'hardvapour',
  'harsh noise',
  'harsh noise wall',
  'hauntology',
  'heartland rock',
  'heavy metal',
  'heavy psych',
  'heavy rock',
  'hi-nrg',
  'highlife',
  'hindustani classical',
  'hip hop',
  'hip house',
  'hiplife',
  'honky tonk',
  'hopepunk',
  'horror punk',
  'horrorcore',
  'house',
  'hyperpop',
  'hyphy',
  'idm',
  'illbient',
  'indian pop',
  'indie',
  'indie folk',
  'indie pop',
  'indie rock',
  'indietronica',
  'indorock',
  'industrial',
  'industrial hardcore',
  'industrial hip hop',
  'industrial metal',
  'industrial musical',
  'industrial rock',
  'industrial techno',
  'instrumental',
  'instrumental jazz',
  'instrumental rock',
  'irish folk',
  'italo dance',
  'italo-disco',
  'j-core',
  'j-pop',
  'j-rock',
  'jaipongan',
  'jazz',
  'jazz blues',
  'jazz fusion',
  'jazz rap',
  'jazz rock',
  'jazz-funk',
  'joik',
  'jùjú',
  'juke',
  'jump blues',
  'jump up',
  'jungle',
  'jungle terror',
  'k-pop',
  'kabarett (German political satire)',
  'kaseko (Suriname)',
  'kasékò (Guiana)',
  'kawaii future bass',
  'kawaii metal',
  'kayōkyoku',
  'keroncong',
  'khyal',
  'kizomba',
  'kleinkunst',
  'klezmer',
  'krautrock',
  'kuduro',
  'kwaito',
  'latin',
  'latin ballad',
  'latin jazz',
  'latin pop',
  'latin rock',
  'latin soul',
  'leftfield',
  'levenslied',
  'line dance',
  'liquid funk',
  'lo-fi',
  'lo-fi hip hop',
  'lolicore',
  'louisiana blues',
  'lounge',
  'lovers rock',
  'lowercase',
  'luk krung',
  'luk thung',
  'madchester',
  'mainstream rock',
  'makossa',
  'maloya',
  'mambo',
  'mandopop',
  'mangue beat',
  'manila sound',
  'march',
  'marchinha',
  'mariachi',
  'marrabenta',
  'martial industrial',
  'maskanda',
  'math rock',
  'mathcore',
  'mbalax',
  'mbaqanga',
  'mbube',
  'medieval',
  'melodic black metal',
  'melodic death metal',
  'melodic dubstep',
  'melodic hardcore',
  'melodic metalcore',
  'melodic rock',
  'melodic trance',
  'mento',
  'merengue',
  'metal',
  'metalcore',
  'miami bass',
  'microhouse',
  'microsound',
  'milonga',
  'min\'yō',
  'mincecore',
  'minimal',
  'minimal drum and bass',
  'minimal techno',
  'minimal wave',
  'mod',
  'modal jazz',
  'modern blues',
  'modern classical',
  'modern country',
  'mood kayō',
  'moombahcore',
  'moombahton',
  'mor lam',
  'morna',
  'motown',
  'mpb',
  'musical',
  'musique concrète',
  'nashville sound',
  'nature sounds',
  'nederpop',
  'neo soul',
  'neo-progressive rock',
  'neo-psychedelia',
  'neo-rockabilly',
  'neo-traditional country',
  'neoclassical dark wave',
  'neoclassical metal',
  'neoclassicism',
  'neofolk',
  'nerdcore',
  'neue deutsche härte',
  'neue deutsche welle',
  'neurofunk',
  'neurohop',
  'new age',
  'new beat',
  'new jack swing',
  'new romantic',
  'new wave',
  'nightcore',
  'no wave',
  'noise',
  'noise pop',
  'noise rock',
  'noisecore',
  'non-music',
  'norteño',
  'northern soul',
  'nova cançó',
  'nu disco',
  'nu jazz',
  'nu metal',
  'nu skool breaks',
  'nueva canción',
  'nueva trova',
  'nuevo flamenco',
  'nuevo tango',
  'nyū myūjikku',
  'occult rock',
  'oi',
  'old school death metal',
  'old-time',
  'onkyo',
  'opera',
  'operatic pop',
  'orchestral',
  'orchestral jazz',
  'outlaw country',
  'p-funk',
  'pachanga',
  'pagodão',
  'pagode',
  'pagode romântico',
  'paisley underground',
  'palm-wine',
  'parang',
  'partido alto',
  'pasodoble',
  'philly soul',
  'phleng phuea chiwit',
  'phonk',
  'piedmont blues',
  'plena',
  'plunderphonics',
  'political hip hop',
  'polka',
  'pop',
  'pop metal',
  'pop punk',
  'pop rap',
  'pop rock',
  'pop soul',
  'pornogrind',
  'porro',
  'post-bop',
  'post-classical',
  'post-grunge',
  'post-hardcore',
  'post-metal',
  'post-minimalism',
  'post-punk',
  'post-rock',
  'power electronics',
  'power metal',
  'power noise',
  'power pop',
  'powerviolence',
  'production music',
  'progressive',
  'progressive bluegrass',
  'progressive country',
  'progressive folk',
  'progressive house',
  'progressive metal',
  'progressive pop',
  'progressive rock',
  'progressive trance',
  'psybient',
  'psychedelic',
  'psychedelic folk',
  'psychedelic pop',
  'psychedelic rock',
  'psychobilly',
  'psytrance',
  'pub rock',
  'punk',
  'punk blues',
  'punk rap',
  'punk rock',
  'qawwali',
  'queercore',
  'quiet storm',
  'r&b',
  'ragga',
  'ragga hip-hop',
  'ragga jungle',
  'ragtime',
  'raï',
  'ranchera',
  'rap metal',
  'rap rock',
  'rapcore',
  'rautalanka',
  'rave',
  'rebetiko',
  'red dirt',
  'red song',
  'reggae',
  'reggaeton',
  'rhythmic noise',
  'ritual ambient',
  'rock',
  'rock and roll',
  'rock opera',
  'rockabilly',
  'rocksteady',
  'romantic classical',
  'roots reggae',
  'roots rock',
  'rumba',
  'runo song',
  'ryūkōka',
  'salegy',
  'salsa',
  'samba',
  'samba-canção',
  'samba-choro',
  'samba-exaltação',
  'samba-reggae',
  'samba-rock',
  'sasscore',
  'schlager',
  'schranz',
  'screamo',
  'sea shanty',
  'séga',
  'sertanejo',
  'sertanejo raiz',
  'sertanejo romântico',
  'sertanejo universitário',
  'shibuya-kei',
  'shoegaze',
  'sierreño',
  'singer-songwriter',
  'ska',
  'ska punk',
  'skacore',
  'skate punk',
  'skiffle',
  'skweee',
  'slam death metal',
  'slow waltz',
  'slowcore',
  'sludge metal',
  'smooth jazz',
  'smooth soul',
  'soca',
  'soft rock',
  'son cubano',
  'son montuno',
  'songo',
  'sophisti-pop',
  'soukous',
  'soul',
  'soul blues',
  'soul jazz',
  'southern gospel',
  'southern metal',
  'southern rock',
  'southern soul',
  'space age pop',
  'space ambient',
  'space disco',
  'space rock',
  'spectralism',
  'speed garage',
  'speed metal',
  'speedcore',
  'spoken word',
  'steampunk',
  'stoner metal',
  'stoner rock',
  'street punk',
  'stride',
  'surf rock',
  'swamp pop',
  'swamp rock',
  'swing',
  'symphonic black metal',
  'symphonic metal',
  'symphonic prog',
  'symphonic rock',
  'symphony',
  'synth funk',
  'synth-pop',
  'synthwave',
  'taarab',
  'tango',
  'tech house',
  'tech trance',
  'technical death metal',
  'techno',
  'techno bass',
  'techno kayō',
  'techstep',
  'tecnobrega',
  'teen pop',
  'tejano',
  'terrorcore',
  'texas blues',
  'thrash metal',
  'thrashcore',
  'thumri',
  'timba',
  'tizita',
  'traditional country',
  'trance',
  'trap',
  'trap edm',
  'tribal ambient',
  'tribal house',
  'trip hop',
  'tropical house',
  'tropicália',
  'trot',
  'trova',
  'tsapiky',
  'turbo-folk',
  'turntablism',
  'twee pop',
  'uk drill',
  'uk funky',
  'uk garage',
  'uk hardcore',
  'underground hip hop',
  'urban cowboy',
  'vallenato',
  'vaportrap',
  'vaporwave',
  'vaudeville',
  'viking metal',
  'visual kei',
  'vocal house',
  'vocal jazz',
  'vocal trance',
  'waltz',
  'wave',
  'west coast hip hop',
  'west coast swing',
  'western swing',
  'witch house',
  'wonky',
  'xote',
  'yacht rock',
  'yé-yé',
  'zamba',
  'zamrock',
  'zarzuela',
  'zeuhl',
  'zouk',
  'zydeco'  
]